<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 3v8h8V3H3Zm6 6H5V5h4v4Zm-6 4v8h8v-8H3Zm6 6H5v-4h4v4Zm4-16v8h8V3h-8Zm6 6h-4V5h4v4Zm-6 4v8h8v-8h-8Zm6 6h-4v-4h4v4Z"
    />
  </svg>
</template>
